import { IconButton, Menu } from '@affine/component';
import { NotificationCountService } from '@affine/core/modules/notification';
import { useLiveData, useService } from '@toeverything/infra';
import { NotificationIcon } from '@blocksuite/icons/rc';
import { useCallback, useState } from 'react';

import { NotificationList } from '../notification/list';
import * as styles from './notification-bell.css';

export const NotificationBell = () => {
  const notificationCountService = useService(NotificationCountService);
  const notificationCount = useLiveData(notificationCountService.count$);

  const [open, setOpen] = useState(false);

  const handleOpenChange = useCallback((nextOpen: boolean) => {
    setOpen(nextOpen);
  }, []);

  return (
    <Menu
      rootOptions={{ open, onOpenChange: handleOpenChange }}
      contentOptions={{
        side: 'right',
        sideOffset: -8,
        align: 'start',
      }}
      items={<NotificationList />}
    >
      <div className={styles.bellWrapper}>
        <IconButton size="24" data-testid="notification-bell">
          <NotificationIcon />
        </IconButton>
        {notificationCount > 0 && (
          <span className={styles.badge}>
            {notificationCount > 99 ? '99+' : notificationCount}
          </span>
        )}
      </div>
    </Menu>
  );
};
